import { SIDEBAR_WIDTH_EXPANDED } from 'src/components/sidebar/sidebar.config';

export const TRANSIT_INSIGHTS_FILTER_PANEL_WIDTH = SIDEBAR_WIDTH_EXPANDED;

export const SCHEDULED_TRIP_DURATION = 'Scheduled Trip Duration';
export const ACTUAL_TRIP_DURATION = 'Actual Trip Duration';
export const DAILY_SIGNAL_DELAY_PER_VEHICLE = 'Daily Signal Delay Per Vehicle';
export const TSP_REQUEST_SUCCESS_RATE = 'TSP Request Success Rate';
export const AVERAGE_BUS_SPEED = 'Average Bus Speed';
export const AVERAGE_BUS_UPDATE_INTERVAL = 'Average Bus Update Interval';
export const AVERAGE_TRANSIT_BUS_FLEET_UPDATE_INTERVAL = 'Average Transit Bus Fleet Update Interval';

export const TRANSIT_INSIGHTS_ROUTE_DETAILS_METRICS = [
    SCHEDULED_TRIP_DURATION,
    ACTUAL_TRIP_DURATION,
    DAILY_SIGNAL_DELAY_PER_VEHICLE,
    AVERAGE_BUS_SPEED,
];

export const TRANSIT_INSIGHTS_TSP_METRICS = [
    TSP_REQUEST_SUCCESS_RATE,
];

export const TRANSIT_INSIGHTS_OVERALL_PERFORMANCE_METRICS = [
    AVERAGE_BUS_UPDATE_INTERVAL,
];

export const TRANSIT_INSIGHTS_FILTER_GROUPS = {
    TRANSIT_INSIGHTS: 'Transit Insights',
};

const TRANSIT_INSIGHTS_SIGNAL_PERFORMANCE_METRICS = [
    { id: 'averageGreenLightSuccessRateOverTime', label: 'Average Green Light Success Rate Over Time' },
    { id: 'averageRedLightDelayOverTime', label: 'Average Red Light Delay Over Time' },
    { id: 'averageRedLightDelayByIntersection', label: 'Average Red Light Delay by Intersection' },
];

const TRANSIT_INSIGHTS_TRAVEL_PERFORMANCE_METRICS = [
    { id: 'averageVehicleSpeed', label: 'Average Vehicle Speed' },
    { id: 'segmentTravelTime', label: 'Segment Travel Time' },
    { id: 'averageTripDuration', label: 'Trip Duration' },
    { id: 'travelTimeByHour', label: 'Travel Time by Hour' },
    { id: 'headway', label: 'Headway' },
];

const TRANSIT_INSIGHTS_STOP_PERFORMANCE_METRICS = [
    { id: 'busStopDwellTime', label: 'Bus Stop Dwell Time' },
    { id: 'routePerformanceByStop', label: 'Route Performance by Stop' },
];

export const TRANSIT_INSIGHTS_ROUTE_DETAILS_VISIBILITY_METRIC = {
    id: 'routeDetails',
    label: 'KPIs',
};

export const TRANSIT_INSIGHTS_METRIC_GROUPS = [
    {
        id: 'route-overview',
        label: 'Route Overview',
        metrics: [TRANSIT_INSIGHTS_ROUTE_DETAILS_VISIBILITY_METRIC],
    },
    {
        id: 'signal-performance',
        label: 'Signal Performance',
        metrics: TRANSIT_INSIGHTS_SIGNAL_PERFORMANCE_METRICS,
    },
    {
        id: 'travel-performance',
        label: 'Travel Performance',
        metrics: TRANSIT_INSIGHTS_TRAVEL_PERFORMANCE_METRICS,
    },
    {
        id: 'stop-performance',
        label: 'Stop Performance',
        metrics: TRANSIT_INSIGHTS_STOP_PERFORMANCE_METRICS,
    },
];

/** Chart metrics in the same display order as the side-panel groups. */
export const TRANSIT_INSIGHTS_CHART_FILTER_METRICS = TRANSIT_INSIGHTS_METRIC_GROUPS
    .filter(({ id }) => id !== 'route-overview')
    .flatMap(({ metrics }) => metrics);

/** @deprecated Use TRANSIT_INSIGHTS_CHART_FILTER_METRICS */
export const TRANSIT_INSIGHTS_DAILY_UPDATE_METRICS = TRANSIT_INSIGHTS_CHART_FILTER_METRICS;

export const TRANSIT_INSIGHTS_ALL_FILTER_METRICS = [
    TRANSIT_INSIGHTS_ROUTE_DETAILS_VISIBILITY_METRIC,
    ...TRANSIT_INSIGHTS_CHART_FILTER_METRICS,
];

/** Mask icon filenames used by PerformanceCard when API omits icon. */
export const TRANSIT_INSIGHTS_METRIC_ICONS = {
    [SCHEDULED_TRIP_DURATION]: 'clock.svg',
    [ACTUAL_TRIP_DURATION]: 'clock.svg',
    [DAILY_SIGNAL_DELAY_PER_VEHICLE]: 'signal.svg',
    [AVERAGE_BUS_SPEED]: 'bus.svg',
    [AVERAGE_BUS_UPDATE_INTERVAL]: 'bus.svg',
};

export const TRANSIT_INSIGHTS_GRID_METRICS = [
    {
        description: SCHEDULED_TRIP_DURATION,
        source: 'routeDetails',
        displayTitle: SCHEDULED_TRIP_DURATION,
    },
    {
        description: ACTUAL_TRIP_DURATION,
        source: 'routeDetails',
        displayTitle: ACTUAL_TRIP_DURATION,
    },
    {
        description: DAILY_SIGNAL_DELAY_PER_VEHICLE,
        source: 'routeDetails',
        displayTitle: DAILY_SIGNAL_DELAY_PER_VEHICLE,
        hidePercentile: true,
        fallbackSource: 'overallPerformance',
    },
    {
        description: AVERAGE_BUS_SPEED,
        source: 'routeDetails',
        displayTitle: AVERAGE_BUS_SPEED,
    },
    {
        description: AVERAGE_BUS_UPDATE_INTERVAL,
        source: 'overallPerformance',
        displayTitle: AVERAGE_TRANSIT_BUS_FLEET_UPDATE_INTERVAL,
    },
];
